// IMPORTING APIS
import React, { Fragment, useEffect } from "react";
import { connect } from 'react-redux';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  useMediaQuery,
  Button,
  // useScrollTrigger,
  // Slide,
  Menu,
  MenuItem,
  ListItemIcon
} from "@material-ui/core";
import classNames from 'classnames';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import logoWhite from "./Liberianlogo.png"
import logo from "./Liberian-Registry-logo.png"

// IMPORTING ICONS
import MenuIcon from "@material-ui/icons/Menu";
import HomeIcon from "@material-ui/icons/Home";
import SchoolIcon from "@material-ui/icons/School";
import PersonIcon from "@material-ui/icons/Person";
import BookmarksIcon from "@material-ui/icons/Bookmarks";
import LanguageIcon from '@material-ui/icons/Language';
// import PhoneIcon from '@material-ui/icons/Phone';
// import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SearchIcon from '@material-ui/icons/Search';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
// import LanguageIcon from '@mui/icons-material/Language'
import VideocamIcon from '@material-ui/icons/Videocam';
import {
  setCallState
} from './core/actions/calls';
import {
  localStorageAvailable,
  getDisplayPCFromLocalStorage,
  saveDisplayPCToLocalStorage,
  getDisplayDCFromLocalStorage,
  saveDisplaySCToLocalStorage
} from './Utils/localStorage';

import { getMeetingUserDetails } from './core/chatSideEffects';

// LOCAL-STYLING
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1,
    fontFamily: 'serif'
  },
  newlogo: {
    width: '240px',
    imageRendering: '-webkit-optimize-contrast'
  },
  allflagstext: {
    fontSize: "18px",
    fontStyle: "italic",
    borderLeft: "1px solid #ccc",
    paddingLeft: "13px",
    margin: " 0px 13px",
    float: "left",
    marginTop: "30px",
    letterSpacing: "1px",
    '&:hover': {
      background: 'none',
      color: "#fff "
    },
    color: "#fff "
  },
  fixedAllflagstext: (props: any) => ({
    color: `${props.darkColor} `,
    fontSize: "18px",
    fontStyle: "italic",
    borderLeft: "1px solid #ccc",
    paddingLeft: "13px",
    margin: " 0px 13px",
    float: "left",
    marginTop: "30px",
    letterSpacing: "1px",
    '&:hover': {
      background: 'none',
      color: `${props.darkColor} `
    },

  }),
  allbuttonColor: {
    color: '#fff',
    fontSize: "20px",
    fontFamily: ' Segoe UI',
    fontWeight: 'normal',
    marginLeft: '10px',
    borderRadius: '0px',
    '&:hover': {
      color: '#ffffff',
      background: 'none',

    },
  },

  buttonColor: (props: any) => ({
    color: '#fff',
    fontSize: "16px",
    fontFamily: ' Segoe UI',
    marginLeft: '20px',
    borderRadius: '0px',

    '&:hover': {
      color: '#ffffff',
      background: props.darkColor,
      transition: 'all .3s ease',
      borderRadius: '4px',
      // borderBottom: '2px solid #6FE6E6',
      // borderRadius: '0px',
    },
  }),
  fixedButtonColor: (props: any) => ({
    color: '#000',
    fontSize: "16px",
    fontFamily: ' Segoe UI',
    marginLeft: '20px',
    borderRadius: '0px',

    '&:hover': {
      color: '#ffffff',
      background: props.darkColor,
      transition: 'all .3s ease',
      borderRadius: '4px',
      // borderBottom: '2px solid #6FE6E6',
      // borderRadius: '0px',
    },
  }),
  buttonColorSearch: {
    '& > span:first-child': {
      color: '#fff',
      background: '#d4d4d400',
      padding: ' 6px',
      border: '1px solid #efefef00',
      borderRadius: '5px',
      width: '36px',
    },
    '&:hover': {
      background: 'none',
      color: '#707070'
    },
  },
  fixedButtonColorSearch: {
    '& > span:first-child': {
      color: '#000',
      background: '#d4d4d400',
      padding: ' 6px',
      border: '1px solid #efefef00',
      borderRadius: '5px',
      width: '36px',
    },
    '&:hover': {
      background: 'none',
      color: '#707070'
    },
  },
  buttonEmeColor: {
    background: '#A02225',
    marginRight: '24px',
    '&:hover': {
      background: '#A02225'
    },
  },
  buttonLoginColor: {
    background: '#004990',
    '&:hover': {
      background: '#004990'
    },
  },
  buttonRejoinColor: (props: any) => ({
    background: props.darkColor,
    textTransform: "none",
    height: '40px',
    width: '218px',
    fontSize: '18px',
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 2px 0px rgb(0 0 0 / 0%), 0px 1px 5px 0px rgb(0 0 0 / 0%)',
    '&:hover': {
      background: props.lightColor,
    },
    float: 'right'
  }),
  defaultColor: {
    // background: 'rgb(0 0 0 / 30%)',
    background: 'linear-gradient(to bottom,rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.5) 60%,rgba(0,0,0,0) 100%)',
    boxShadow: '0px 2px 4px -1px rgb(255 255 255 / 0%), 0px 4px 5px 0px rgb(255 255 255 / 0%), 0px 1px 10px 0px rgb(255 255 255 / 0%)',
    height: '100px',
  },
  normalColor: {
    background: '#fff',

  },
  childPageColor: {
    background: '#ffffff'
  },
}));

// function HideOnScroll(props) {
//   const { children } = props;
//   const trigger = useScrollTrigger();

//   return (
//     <Slide appear={false} direction={"down"} in={!trigger}>
//       {children}
//     </Slide>
//   );
// }
const mapDispatchToProps = (dispatch: any) => ({
  setCallState: async (msg: string) => dispatch(setCallState(msg))
});

const mapStateToProps = () => ({
});

export interface HeaderProps {
  page: any;
  loader: any;
  className: any;
  rejoinHandler(): void;
  setCallState(msg: string | null): any;
  darkColor: string;
  lightColor: string;
}

const Header = (props: HeaderProps) => {
  const classes = useStyles(props);
  const [anchor, setAnchor] = React.useState(null);
  const [rejoinButton, setRejoinButton] = React.useState(false);
  const open = Boolean(anchor);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleMenu = (event: any) => {
    setAnchor(event.currentTarget);
  };
  // console.log(localStorageAvailable, getDisplayPCFromLocalStorage())
  // console.log(props.className)
  let myInterval: any;
  useEffect(() => {
    // console.log(props.page)
    if (props.page === 'endCall') {
      const urlParams = new URLSearchParams(window.location.search);
      const meetingId = urlParams.get('meetingId');
      if (meetingId) {
        getMeetingInfoData();
        const autoCallEndingAPIRunningTime: any = (sessionStorage.getItem('autoCallEndingAPIRunningTime') ? sessionStorage.getItem('autoCallEndingAPIRunningTime') : 60);
        // console.log(autoCallEndingAPIRunningTime, 'autoCallEndingAPIRunningTime')
        myInterval = setInterval(() => {
          const meetingId = urlParams.get('meetingId');
          if (meetingId) {
            getMeetingInfoData();
          }
        }, Number(autoCallEndingAPIRunningTime) * 1000)
        return () => {
          clearInterval(myInterval);
        };
      }
    }
  }, [props.page])
  // console.log(props.page)
  const getMeetingInfoData = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const meetingId = urlParams.get('meetingId');
    const userInfo: any = await getMeetingUserDetails({ meetingId: meetingId, serverCallId: null });
    // console.log(userInfo, 'userInfo')
    if (userInfo && userInfo.data) {
      const userInfoData = userInfo.data;
      if (userInfoData && userInfoData.success) {
        const totalCount = Number(userInfoData.data.customersCount) + Number(userInfoData.data.employeeCount)
        // console.log(totalCount, 'totalCount')
        if (totalCount > 0) {
          setRejoinButton(true)
        } else {
          setRejoinButton(false)
          clearInterval(myInterval);
        }
      }
    }
  }

  return (
    <div className={classes.root}>
      <AppBar className={(props.page === 'configuration' && props.loader) ? (props.className == 'default' ? classes.defaultColor : classes.normalColor) : classes.childPageColor}>
        <Toolbar>
          {(props.page !== 'call' || isMobile) && <a href='https://www.liscr.com/' target={'_blank'}>  <img src={props.className == 'default' ? (props.page === 'configuration' && props.loader) ? logoWhite : logo : logo} className={classes.newlogo} alt="logo" /></a>}
          {/* <Typography
            variant="h5"
            component="p"
            color="secondary"
            className={classNames(classes.title, classes.allbuttonColor, (props.page === 'configuration' && props.loader) ? props.className == 'default' ? classes.allflagstext : classes.fixedAllflagstext : classes.fixedAllflagstext)}
            style={{
              color: (props.page === 'configuration' && props.loader) ? props.className == 'default' ? '#fff ' : `${props.darkColor} ` : `${props.darkColor} `
            }}
          >
            All flags are not alike
          </Typography> */}
          {isMobile ? (
            <div style={{ display: 'none' }}>
              <IconButton
                color="secondary"
                className={classes.menuButton}
                edge="start"
                aria-label="menu"
                onClick={handleMenu}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchor}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                // KeepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                open={open}
              >
                <MenuItem
                  onClick={() => setAnchor(null)}
                  component={Link}
                  to="/"
                >
                  <ListItemIcon>
                    <HomeIcon />
                  </ListItemIcon>
                  <Typography variant="h6"> Home</Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => setAnchor(null)}
                  component={Link}
                  to="/College"
                >
                  <ListItemIcon>
                    <SchoolIcon />
                  </ListItemIcon>
                  <Typography variant="h6"> College </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => setAnchor(null)}
                  component={Link}
                  to="/About"
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <Typography variant="h6"> About</Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => setAnchor(null)}
                  component={Link}
                  to="/Personal"
                >
                  <ListItemIcon>
                    <BookmarksIcon />
                  </ListItemIcon>
                  <Typography variant="h6"> Personal </Typography>
                </MenuItem>
              </Menu>
            </div>
          ) : (
            <Fragment>
              <div style={{ display: (props.page === 'configuration' && props.loader) ? 'none' : 'none' }}>
                <Button
                  variant="text"
                  component={Link}
                  to="/"
                  // color="secondary"
                  className={props.className == 'default' ? classes.buttonColor : classes.fixedButtonColor}
                // style={{ background: props.lightColor }}
                >
                  {/* <HomeIcon /> */}
                  Why Us
                </Button>
                <Button
                  variant="text"
                  component={Link}
                  to="/"
                  // color="secondary"
                  className={props.className == 'default' ? classes.buttonColor : classes.fixedButtonColor}
                >
                  {/* <SchoolIcon /> */}
                  Vessel Registration
                </Button>
                <Button
                  variant="text"
                  component={Link}
                  to="/"
                  // color="secondary"
                  className={props.className == 'default' ? classes.buttonColor : classes.fixedButtonColor}
                >
                  {/* <PersonIcon /> */}
                  Maritime
                </Button>
                <Button
                  variant="text"
                  component={Link}
                  to="/"
                  // color="secondary"
                  className={props.className == 'default' ? classes.buttonColor : classes.fixedButtonColor}
                >
                  {/* <BookmarksIcon /> */}
                  Seafarers
                </Button>

                <Button
                  variant="text"
                  component={Link}
                  to="/"
                  // color="secondary"
                  className={props.className == 'default' ? classes.buttonColor : classes.fixedButtonColor}
                >
                  {/* <BookmarksIcon /> */}
                  Corporate Registry
                </Button>


                <Button
                  variant="text"
                  component={Link}
                  to="/"
                  // color="secondary"
                  className={props.className == 'default' ? classes.buttonColor : classes.fixedButtonColor}
                >
                  {/* <BookmarksIcon /> */}
                  About Us
                </Button>

                {/* <Button
                variant="text"
                component={Link}
                to="/Personal"
                // color="secondary"
                className={classes.buttonColor}
              >
                Menu 6
              </Button> */}

                <Button style={{ width: '36px', marginLeft: '15px' }}
                  variant="text"
                  component={Link}
                  to="/"
                  // color="default"
                  className={props.className == 'default' ? classes.buttonColorSearch : classes.fixedButtonColorSearch}
                >
                  <SearchIcon />

                </Button>


                <Button style={{ width: '36px' }}
                  variant="text"
                  component={Link}
                  to="/"
                  // color="default"
                  className={props.className == 'default' ? classes.buttonColorSearch : classes.fixedButtonColorSearch}
                >
                  <LanguageIcon />

                </Button>
                <Button style={{ width: '36px' }}
                  variant="text"
                  component={Link}
                  to="/"
                  // color="default"
                  className={props.className == 'default' ? classes.buttonColorSearch : classes.fixedButtonColorSearch}
                >
                  <ExitToAppIcon />

                </Button>




                {/* <Button variant="contained" startIcon={<PhoneIcon />} color="secondary" className={classes.buttonEmeColor}>
                Emergency
              </Button>
              <Button variant="contained" startIcon={<ExitToAppIcon />} color="secondary" className={classes.buttonLoginColor}>
                Login
              </Button> */}
              </div>
              <div style={{ display: (props.page === 'endCall') ? 'block' : 'none', width: '88%' }}>
                {rejoinButton &&
                  <Button
                    variant="contained"
                    startIcon={<VideocamIcon />}
                    color="secondary"
                    className={classes.buttonRejoinColor}
                    onClick={() => { props.rejoinHandler(); props.setCallState('Connected'); }}
                  >
                    Rejoin call
                  </Button>
                }
              </div>
            </Fragment>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
